import { useContext, useEffect, useRef } from "react";
import globalStates from "../../utils/global";
import "./ScreenTemplate.css"
import { NewScreen1Background } from "../../assets";

const ScreenTemplate = () =>{

    const context = globalStates && globalStates.globalContext;
    const globalContext:any = useContext(context);
    const windowWidthClass = globalContext && globalContext.windowWidthClass;
    
    // const businessDetailImagesImg = businessDetailImages && businessDetailImages.screenBannerImg;

    const screenWebsiteRef = useRef(null) as any;
    // console.log({})
    useEffect(()=>{
        const handleScroll =()=>{
            const setScreensOffset = globalContext && globalContext.setScreensOffset;
            const screenWebsite = screenWebsiteRef.current.getBoundingClientRect();
            const top = screenWebsite.top;
            const bottom = screenWebsite.bottom;
            const offset = globalContext && globalContext.windowHeight;
            setScreensOffset((prev:any)=>{return {...prev, 
                isOffsetscreenWebsite: false, bottom, offset, top
            }});
            if(top < (-1*0.005*offset) ){
                setScreensOffset((prev:any)=>{return {...prev, bottom, offset, top,
                    isOffsetscreenWebsite: true,
                }});
            };
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
        window.removeEventListener('scroll', handleScroll);
        };
    }, [globalContext])

    const componentData = {
        background: {
            image: {
                src: "",
                alt: ""
            }
        },
        shield: {

        },
        content: {

        }
    }
    
    return(
        <>
            <div 
            ref={screenWebsiteRef} 
            className={`${windowWidthClass}-screen-new-2 wrapper`}>

                <div className="background">
                    <div className="frame">
                        <img
                            alt = {componentData.background.image.alt}
                            src = {componentData.background.image.src}
                        />
                    </div>
                </div>
                <div className="shield">

                </div>
                <div className="content display">
                    {/* <h1>new screen content</h1> */}
                 
                    <div className="text-div part-2">
                        <p className="news">Kuno Cultures harnesses heritage Indonesian cultures (yes, pun intended!) the power of mycelium-based fermentation to turn locally sourced Swedish legumes and seeds as well as upcycle food waste into diversified, flavourful, nutrient-rich food. Our mission is to celebrate and preserve food diversity while making sustainable eating accessible and inclusive.</p>
                    </div>
                    <div className="text-div part-3">
                        <h2 className="tagline-2">Turning locally available legumes & seeds into Flavorful, Soulful Foods—Rooted in Indonesian Heritage Knowledge of Mycelium Fermentation.</h2>
                    </div>
                </div>

            </div>
        </>
        
    )
};

export default ScreenTemplate;